import { Link } from "react-router-dom";
import { PendingOrderProgressBarVisibleConstansts } from "../../common/constants";
import PendingOrderProgressBar from "./PendingOrderProgressBar";

// export const columns = [
//   {
//     Header: "Order #/Ref #",
//     accessor: "fileNumber",
//     width: 30,
//     Cell: ({ row }) => {
//       //spread the props
//       const redirectURL = `process/${row.original.filenumberEncrypted}`;
//       return (
//         <div className="ml-3">
//           <a href={redirectURL} className="fileNumber text-secondary-blue">
//             {row.original.fileNumber}
//           </a>
//           <br />
//           <span className="internalReference">
//             {row.original.internalReference}
//           </span>
//         </div>
//       );
//     },
//   },
//   {
//     Header: "reference",
//     accessor: "internalReference",
//     width: 30,
//   },
//   {
//     Header: "Lawyer Name",
//     accessor: "lawyerName",
//     width: 100,
//   },
//   {
//     Header: "Client Name",
//     accessor: "clients",
//     width: 140,
//   },
//   {
//     Header: "Property Address",
//     accessor: "propertyAddress",
//     width: 350,
//     itemsToShow: 3,
//     expanded: false,
//   },
//   {
//     Header: "Deal Type",
//     accessor: "dealType",
//     width: 100,
//   },
//   {
//     Header: "Issue Date",
//     accessor: "issueDate",
//     width: 100,
//   },
//   {
//     Header: "Documents",
//     //accessor: "status",
//     width: 50,
//     ToolTip: true,
//     Cell: ({ row }) => {
//       //spread the props
//       return (
//         <div className="ml-1">
//           <button className="cursor-pointer flex float-left font-[600] items-center justify-center px-[5px] text-[#526D7D] w-max">
//             View Docs
//           </button>
//         </div>
//       );
//     },
//   },
// ];

export const formatRowData = (rawData,lang) => {
  return rawData.map((info) => ({
    fileNumber: info.fileNumber,
    fileID: info.fileID,
    filenumberEncrypted: info.encryptedURL,
    lawyerName: info.lawyerName,
    internalReference: info.internalReference,
    propertyAddress: info.propertyAddress,
    clients: info.clients,
    closingDate:
      info.closingDate === null || info.closingDate === ""
        ? "-"
        : info.closingDate,
     dealType: info.co === "IDV"? (lang=="en"?"ID Verification":"Vérification d'identité" ): info.co === "Co" ? (lang=="en"?"Commercial":"Commercial" ): (lang=="en"?"Residential":"Résidentiel")
  }));
};

export const getData = async (pageNo = 1) => {
  const response = await fetch(
    `https://api.instantwebtools.net/v1/passenger?page=${pageNo}&size=15`
  );
  const data = await response.json();
  return data;
  //   fetch(
  //     `https://api.instantwebtools.net/v1/passenger?page=${pageNo}&size=10`
  //   ).then((res) => res.json().then((data) => console.log(data)));
};
